import PageShell from "@/components/PageShell";
import { Equipos } from "@/components/landing/Equipos";

export default function EquiposPage() {
  return (
    <PageShell crumbs={[{ label: "Equipos" }]}>
      <Equipos />
    </PageShell>
  );
}
